import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

// Permisos efectivos del usuario logueado
export const fetchMisPermisos = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/mios`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`,
                'Cache-Control': 'no-cache'
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Catálogo completo de permisos
export const fetchCatalogoPermisos = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/catalogo`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Catálogo + asignaciones (roles + usuarios) en una sola llamada (Fase 1).
// Devuelve { permisos: [{ Id, clave, nombre, descripcion, roles:[], usuarios:[] }] }
export const fetchConfiguracionPermisos = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/configuracion`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data.permisos || [];
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Detalle de un permiso
export const fetchPermisoDetalle = async (clave) => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/${clave}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Actualizar roles y usuarios asignados a un permiso
export const updatePermiso = async (clave, datos) => {
    try {
        const response = await axios.put(
            `${API_URL}/api/permisos/${clave}`,
            datos,
            {
                headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
            }
        );
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Lista de usuarios asignables (incluye unidadesNegocio y departamentos por usuario)
export const fetchUsuariosAsignables = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/usuarios-asignables`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// RENOMBRADO: antes fetchEmpresasFiltro
// Catálogo de unidades de negocio para el select de filtro
export const fetchUnidadesNegocioFiltro = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/unidades-negocio`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Catálogo de departamentos para el select de filtro
export const fetchDepartamentosFiltro = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/permisos/departamentos`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
